import { SVGProps, Ref, forwardRef } from 'react';

export const UserCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 6.5 3.75 1 12 1s11 5.5 11 11c0 3.634-1.2 7.269-4.396 9.316C18.477 16.587 15.238 15 12 15s-6.476 1.587-6.604 6.316C2.201 19.27 1 15.635 1 12m15.808 10.211c-1.34.505-2.932.789-4.808.789s-3.468-.285-4.808-.789v-.603c0-2.045.661-3.15 1.418-3.78.814-.678 2.006-1.028 3.39-1.028s2.576.35 3.39 1.028c.757.63 1.418 1.735 1.418 3.78zM9.8 9.5c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602c-.271-.326-.458-.865-.458-1.598M8 9.5c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserCircleFilledSize24Glyph.displayName = 'UserCircleFilledSize24Glyph';
